import type { CurpExtractionState } from '../../services/curpExtraction.service';

// ¿El estado del backend trae evidencia de que YA existe una extracción real
// (en curso o terminada)? Es la base de la idempotencia: si hay evidencia, no
// hay que volver a disparar la extracción — solo observar. Si no, el GET
// devuelve un `pending` "fantasma" (sources.present=false) y sí hay que dispararla.
export const hasExtractionEvidence = (curp: CurpExtractionState): boolean =>
	!!curp.extracted_at ||
	curp.extraction_success != null ||
	!!curp.extraction_error ||
	curp.sources?.extraction?.present === true ||
	curp.sources?.validation?.present === true ||
	!!curp.rfc ||
	!!curp.nombre_completo ||
	!!curp.nombre ||
	(curp.regimes?.length ?? 0) > 0;
